import RichEditor from 'Components/RichEditor';
import BlockActionsMenu from 'Components/RichEditor/Components/BlockActionsMenu';
import FormattingMenu from 'Components/RichEditor/Components/FormattingMenu';
import useAutoSave from 'hooks/useAutoSave';
import { useEffect, useMemo, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useGetSurveyQuery, useUpdateSurveyMutation } from 'store/services/feedbackGroup';
import Title from 'style-guide/Typography/Title';

const Introduction = ({ setPreviewData }) => {
  const { surveyId } = useParams();
  const { data, isSuccess } = useGetSurveyQuery({ surveyId });
  const [lastSavedContent, setLastSavedContent] = useState('');
  const [editableContent, setEditableContent] = useState('');
  const [hasChange, setHasChange] = useState(false);

  const [updateSurveyDescription] = useUpdateSurveyMutation();

  const requestData = useMemo(
    () => ({
      description: editableContent,
      id: surveyId,
    }),
    [editableContent, surveyId]
  );

  // Sync content when data is loaded
  useEffect(() => {
    if (isSuccess && editableContent === '') {
      setEditableContent(data?.description);
      setLastSavedContent(data?.description);
      // Update preview data with initial description
      setPreviewData({ description: data?.description });
    }
  }, [data?.description, editableContent, isSuccess, setPreviewData]);

  // Track unsaved changes
  useEffect(() => {
    setHasChange(editableContent !== lastSavedContent);
  }, [editableContent, lastSavedContent]);

  // Update preview data when content changes
  useEffect(() => {
    setPreviewData({ description: editableContent });
  }, [editableContent, setPreviewData]);

  useAutoSave({
    request: updateSurveyDescription,
    requestData,
    hasChange,
    callback: () => setLastSavedContent(editableContent),
  });

  // Avoid rendering editor until content is loaded
  const shouldRenderEditor = isSuccess && editableContent !== '';

  return (
    <div className='col-xl-8 offset-xl-2 mt--32'>
      <Title variant={2}>Introduction...</Title>

      {shouldRenderEditor ? (
        <RichEditor onChange={setEditableContent} content={editableContent} outputIsHtml>
          <FormattingMenu />
          <BlockActionsMenu />
        </RichEditor>
      ) : (
        <div>Loading editor...</div>
      )}
    </div>
  );
};

export default Introduction;
